import React from 'react';
import { Alert, Button, CircularProgress, Stack, TextField } from '@mui/material';
import { ArrowBackOutlined, PasswordOutlined } from '@mui/icons-material';
import { Link as RouterLink } from 'react-router-dom';
import AuthShell from '../components/AuthShell';
import { AuthAPI } from '../api/auth';
import { ROUTES } from '../routes';

export default function ForgotPasswordPage() {
  const [email, setEmail] = React.useState('');
  const [loading, setLoading] = React.useState(false);
  const [msg, setMsg] = React.useState('');
  const [error, setError] = React.useState('');

  const submit = async (event) => {
    event.preventDefault();
    setMsg('');
    setError('');
    setLoading(true);
    try {
      await AuthAPI.requestReset(email.trim());
      setMsg('If the email exists, a reset link has been sent.');
    } catch {
      setMsg('If the email exists, a reset link has been sent.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell
      title="Forgot password"
      subtitle="We will send a reset link to your email."
      sideTitle="Recover access quickly"
      sideBody="Your users can regain access without involving support, while the reset flow stays secure and simple."
    >
      <Stack component="form" spacing={2} onSubmit={submit}>
        {msg ? <Alert severity="success">{msg}</Alert> : null}
        {error ? <Alert severity="error">{error}</Alert> : null}

        <TextField label="Email Address" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required />

        <Button type="submit" variant="contained" disabled={loading} startIcon={<PasswordOutlined />}>
          {loading ? <CircularProgress size={22} sx={{ color: '#fff' }} /> : 'Send reset link'}
        </Button>

        <Button component={RouterLink} to={ROUTES.LOGIN} variant="outlined" startIcon={<ArrowBackOutlined />}>
          Back to sign in
        </Button>
      </Stack>
    </AuthShell>
  );
}
